module.exports = __webpack_public_path__ + "static/media/a5.e4aebd6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caoxi/a5.mp3
// module id = 7VoU
// module chunks = 0